import { useState, useMemo, useEffect } from "react";
import "./App.scss";

import { ConfigProvider, notification, theme } from "antd";
import { ColorModeContext } from "Helpers/contexts";
import { UserContextProvider } from "Hooks/UserContext";
import AppLayout from "Components/Shared/AppLayout";
import { QueryClient, QueryClientProvider } from "react-query";
import { ServicesProvider } from "Hooks/ServicesContext";
import { getDesignTokens } from "Helpers/ats.helper";
import { ThemeProvider } from "./ThemeProvider";
import { NotificationContext } from "Hooks/NotificationContext";
import { Spin } from "antd";

Spin.setDefaultIndicator(<span className="depo-loader"></span>);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      cacheTime: 0,
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

function App() {
  const [mode, setMode] = useState(() => {
    const storedMode = localStorage.getItem("mode");
    return storedMode ? JSON.parse(storedMode) : true;
  });

  notification.config({
    stack: { threshold: 5 },
    duration: 3000
  });

  useEffect(() => {
    try {
      localStorage.setItem("mode", JSON.stringify(mode));
    } catch (error) {}
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => !prevMode);
      }
    }),
    []
  );

  const [api, contextHolder] = notification.useNotification();

  const designTokens = useMemo(() => getDesignTokens(mode, theme), [mode]);

  const depoNotify = (message, config) => {
    api[config?.variant || "info"]({
      message: message,
      ...config
    });
  };

  return (
    <>
      <ConfigProvider theme={designTokens}>
        <ThemeProvider theme={designTokens}>
          <QueryClientProvider client={queryClient}>
            <ColorModeContext.Provider value={{ colorMode, mode }}>
              <NotificationContext.Provider value={{ depoNotify }}>
                {contextHolder}
                <UserContextProvider>
                  <ServicesProvider>
                    <div className={"appContainer " + (mode ? "light" : "dark")}>
                      <AppLayout />
                    </div>
                  </ServicesProvider>
                </UserContextProvider>
              </NotificationContext.Provider>
            </ColorModeContext.Provider>
          </QueryClientProvider>
        </ThemeProvider>
      </ConfigProvider>
    </>
  );
}

export default App;
